<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/basic/defectType/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('yijiquexianleixingbianma')">
						<el-input v-model="yt.conditions.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('yijiquexianleixingmingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy:'code asc',level:1})">{{$t('chongzhi')}}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button v-if="utils.checkPower('web_base_defect_type_create')" size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setDefaultValue()" type="primary">
					{{$t('xinzeng')}}
				</el-button>
				<el-button v-if="utils.checkPower('web_base_defect_type_batchImport')" size="mini" @click="show = !show" plain>
					{{$t('daoru')}}
				</el-button>
			</template>
			
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_base_defect_defectType')" type="text" @click="yt.showEditDialog('erjiquexianleixing', scope.row,'w2')">{{$t('erjiquexianleixing')}}</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_base_defect_type_update')" type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="utils.checkPower('web_base_defect_type_delete')" type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/basic/defectType/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('yijiquexianleixingbianma')" required>
						<el-input v-model.trim="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('yijiquexianleixingmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/basic/defectType/create')"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 编辑 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder" :label="$t('yijiquexianleixingbianma')" required>
						<el-input disabled v-model.trim="yt.editObj.code"></el-input>
					</el-form-item>
					<el-form-item :label="$t('yijiquexianleixingmingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/basic/defectType/update')"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 查看工单BOM -->
			<template v-if="yt.editObj.action == 'erjiquexianleixing'">
				<div class="dialog-scroller">
					<secondary :type="yt.editObj"></secondary>
				</div>
			</template>
		</el-dialog>
		<!-- 导入excel -->
		<importExcel :show.sync="show" />
	</div>
</template>
<script type="text/javascript">
	import importExcel from '@@/pages/web/base/defect/defect_type/import_excel'
	import secondary from '@@/pages/web/base/defect/defect_type/secondary'
	export default {
		name: 'web_base_defect_defect_type_list',
		components: {
			secondary,
			importExcel
		},
		data() {
			return {
				show: false,
				columns: [ {
					label: 'yijiquexianleixingbianma',
					prop: 'code',
					width: 150
				}, {
					label: 'yijiquexianleixingmingcheng',
					prop: 'name',	
				}, 
				{
					label: 'chuangjianren',
					prop: 'createByObject.nickname',
					// width: 180
				},
				{
					label: 'chuangjianshijian',
					prop: 'createTime',
					type: 'time',
					// width: 180
					// format: 'YYYY-MM-DD HH:mm'
				}, 
				{
					label: 'caozuo',
					type: 'slot',
					width: 230,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy:'code asc',
          level:1
				}
				this.yt.get(1);
				this.utils.event_hub.$on('WEB_DEFECT_TYPE_REFRESH', () => {
					this.yt.get(1);
				})
			}, 300)
		},
		methods: {
		setDefaultValue(){
			this.yt.editObj.level = 1;
		},
		}
	};
</script>
